import { graphqlApolloClient } from "../graphql-apollo-client"
import {
  SUBMISSION_SETTINGS_QUERY,
  CREATE_LOCKED_ASSISTANCE_DATES,
  UPDATE_LOCKED_ASSISTANCE_DATES
} from "./graphql"

const getSubmissionSettings = async ({ submissionId }) => {
  const { data } = await graphqlApolloClient.query({
    query: SUBMISSION_SETTINGS_QUERY,
    fetchPolicy: "network-only",
    variables: { submissionId }
  })

  return data?.SubmissionSettings
}

const createSubmissionSettings = async ({
  submissionId,
  lockedAssistanceDates
}) => {
  const { data } = await graphqlApolloClient.mutate({
    mutation: CREATE_LOCKED_ASSISTANCE_DATES,
    variables: { submissionId, lockedAssistanceDates }
  })

  return data?.CreateLockedAssistanceDates
}

const updateSubmissionSettings = async ({
  submissionSettingsId,
  lockedAssistanceDates
}) => {
  const { data } = await graphqlApolloClient.mutate({
    mutation: UPDATE_LOCKED_ASSISTANCE_DATES,
    variables: { submissionSettingsId, lockedAssistanceDates }
  })

  return data?.UpdateLockedAssistanceDates
}

export const submissionSettingsService = {
  getSubmissionSettings,
  createSubmissionSettings,
  updateSubmissionSettings
}
